import { useMutation } from '@tanstack/react-query';
import useSlingApi from '@sdk/api/useSlingApi';
import { AddCommentPayload } from '@sdk/newsfeed/types/apiTypes';

import { useNewsfeedMappers } from '@web/newsfeed/hooks/useNewsfeedMappers';
import { useNewsfeedBridge } from '@web/newsfeed/NewsfeedBridgeProvider/NewsfeedBridgeProvider';
import { useArticleCommentsQueryCache } from '@web/newsfeed/Article/ArticleComments/hooks/useArticleCommentsQueryCache';

export const useAddComment = () => {
  const { addComment } = useArticleCommentsQueryCache();
  const { newsfeedComments } = useSlingApi();
  const { mapAPIArticleCommentToUI } = useNewsfeedMappers();
  const newsfeedBridge = useNewsfeedBridge();

  const mutation = useMutation({
    mutationFn: async (payload: AddCommentPayload) => {
      const result = await newsfeedComments.add(payload);
      return mapAPIArticleCommentToUI(result.data);
    },
    onSuccess: (payload) => {
      addComment(payload);
      newsfeedBridge.onAddComment(payload);
    },
  });

  return mutation;
};
